import { render } from "./ArticlesInsight.vue?vue&type=template&id=17d96146"
import script from "./ArticlesInsight.vue?vue&type=script&lang=js"
export * from "./ArticlesInsight.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__